'use client'

import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { ArticleCard } from 'my-purchases/components/ArticleCard/ArticleCard'
import {
	PRODUCT_STATUS,
	PRODUCT_STATUS_LABELS,
} from 'my-purchases/constants/productStatus'
import { useArticle } from 'my-purchases/hooks/useArticle/useArticle'
import type { OrderLineWithFormattedPrices } from 'my-purchases/types/purchaseCommon'

interface OrderArticleProps {
	readonly article: OrderLineWithFormattedPrices
	readonly isDisabled?: boolean
}
export function OrderArticle({ article, isDisabled }: OrderArticleProps) {
	const { t } = useLabels()
	const { article: articleData } = useArticle({
		articleItem: article,
	})

	if (!articleData) {
		return null
	}

	const { name, reference, id, image, size, status, color, prices, url } =
		articleData

	const articleStatus =
		PRODUCT_STATUS_LABELS[status as keyof typeof PRODUCT_STATUS_LABELS] ?? ''

	return (
		<ArticleCard
			data-testid='myPurchases.details.item'
			name={name}
			reference={reference}
			uniqueId={id}
			imgSrc={image ?? ''}
			size={size}
			isDisabled={
				isDisabled ||
				[
					PRODUCT_STATUS.RETURN_REQUESTED,
					PRODUCT_STATUS.RETURNED,
					PRODUCT_STATUS.OUT_OF_STOCK,
				].includes(status)
			}
			color={color}
			prices={prices}
			{...(url && {
				linkConfig: {
					href: url,
				},
			})}
			{...(articleStatus && {
				status: {
					statusMessage: t(articleStatus),
					isAlert: status === PRODUCT_STATUS.OUT_OF_STOCK,
				},
			})}
		/>
	)
}
